import { TimelineItem, TimelineItemId } from 'framework/ui/timeline';

export interface StrategyDto {
  id: TimelineItemId;
  timelineId?: TimelineItemId;
  description: string;
  createdAt: string;
  createdById: StringOrNumber;
  createdByName: string;
  updatedAt: string;
  updatedById: StringOrNumber;
  updatedByName: string;
  isPinned?: boolean;
}

export interface StrategyTimelineItem extends NonNullable<TimelineItem> {
  strategyNote: StrategyDto;
}

export const isStrategyTimelineItem = (item: TimelineItem): item is StrategyTimelineItem =>
  Boolean(item && typeof item === 'object' && 'strategyNote' in item && item.strategyNote);
